import { cilPen } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CInputGroup,
  CModal,
} from '@coreui/react'
import React from 'react'
import { toTanggal } from 'src/module/helpers'
import DatePicker from 'react-datepicker'

import range from 'lodash.range'
import getYear from 'date-fns/getYear'
import getMonth from 'date-fns/getMonth'
// import { CDatePicker } from '@coreui/react'
// or
// import CDatePicker from '@coreui/react/src/components/datepicker/CDatePicker'

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const tahun = new Date().getFullYear()

const years = range(1950, tahun + 1, 1)

// console.log(inputProps)

const months = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
]

const AturTanggal = ({ setStartDate, selectedDate }) => {
  return (
    <DatePicker
      selected={selectedDate}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <button onClick={decreaseMonth} type="button" disabled={prevMonthButtonDisabled}>
            {'<'}
          </button>
          <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button">
            {'>'}
          </button>
        </div>
      )}
      todayButton="Hari Ini"
      onChange={(date) => {
        setStartDate(date)
        // setTanggalHasChange('change')
        // setVisibleModal(false);
        // input.onChange(date)
      }}
      inline
    />
  )
}

export default class CustomRenderSelect extends React.Component {
  constructor(props) {
    super(props)
    const { input } = props
    this.state = {
      startDate: input?.value || new Date(),
      visible: false,
      statTangggal: 'idle',
    }
  }

  handleChange = (event) => {
    const { input } = this.props
    const valueSelect = event.target.value
    let visible = false
    let statTangggal = 'idle'
    let startDate = this.state.startDate

    if (valueSelect === '1') {
      startDate = new Date()
      input.onChange(startDate)
      statTangggal = 'change'
    }
    if (valueSelect === '2') {
      visible = true
      startDate = new Date()
    }

    this.setState({
      startDate,
      valueSelect,
      visible,
      statTangggal,
    })
  }

  UbahTanggalSelesai = (value) => {
    const { input } = this.props
    input.onChange(null)
    this.setState({
      valueSelect: '',
      visible: false,
      statTangggal: 'idle',
    })
  }

  setStartDate = (date) => {
    // console.log(date)
    const { input } = this.props
    input.onChange(date)

    this.setState({
      startDate: date,
      visible: false,
      statTangggal: 'change',
    })
  }

  HandleCloseModalTanggal = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { valueSelect, startDate, visible } = this.state
    const { meta, input } = this.props
    // console.log(this.state)
    return (
      <div className={'mb-3'}>
        <CFormLabel className="sm" htmlFor="exampleFormControlInput1">
          Tanggal Registrasi
        </CFormLabel>
        {input.value && (
          <React.Fragment>
            <CInputGroup size="sm" className="mb-3">
              <CFormInput size="sm" value={toTanggal(input.value, 'DD MMMM YYYY')} readOnly />
              <CButton
                type="button"
                color="secondary"
                variant="outline"
                id="button-addon2"
                title="Ubah Tanggal Selesai"
                onClick={this.UbahTanggalSelesai}
              >
                <CIcon icon={cilPen} />
              </CButton>
            </CInputGroup>
          </React.Fragment>
        )}
        {!input.value && (
          <CFormSelect
            size="sm"
            aria-label="Small select example"
            onChange={this.handleChange}
            value={valueSelect}
          >
            <option value="">Pilih Tanggal Registrasi</option>
            <option value="1">Sama dengan tanggal Hari ini</option>
            <option value="2">Atur tanggal Registrasi</option>
          </CFormSelect>
        )}

        <CModal
          alignment="center"
          backdrop="static"
          visible={visible}
          size="sm"
          onClose={this.HandleCloseModalTanggal}
          aria-labelledby="LiveDemoExampleLabel"
        // unmountOnClose={false}
        >
          <div className="w-100 p-2 d-flex align-items-end bg-primary rounded-top rounded-end">
            <span className="text-white fw-bolder">Atur Tanggal Registrasi</span>
            <div className="ms-auto">
              <button
                className="btn-close btn-close-white fw-bolder"
                onClick={() => this.HandleCloseModalTanggal()}
              ></button>
            </div>
          </div>

          <div className="p-2">
            <center>
              <AturTanggal selectedDate={startDate} setStartDate={this.setStartDate} />
            </center>
          </div>
        </CModal>

        {meta.error && meta.touched && (
          <span>
            {' '}
            <CFormFeedback className="d-block" invalid>
              {meta.error}
            </CFormFeedback>
          </span>
        )}
      </div>
    )
  }
}
